import React from 'react';
import styled from 'styled-components';
import { Wallet, Config } from '../types';

const StatsContainer = styled.div`
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
`;

const StatCard = styled.div`
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 16px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  flex: 1;
  min-width: 200px;
  text-align: center;
  transition: all 0.3s ease;
`;

const StatValue = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 4px;
  transition: color 0.3s ease;
`;

const StatLabel = styled.div`
  font-size: 0.875rem;
  color: var(--text-secondary);
  font-weight: 500;
  transition: color 0.3s ease;
`;

const StatIcon = styled.span`
  font-size: 1.2rem;
  margin-right: 8px;
`;

const SettingsContainer = styled.div`
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 20px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  margin-top: 16px;
  transition: all 0.3s ease;
`;

const SettingsTitle = styled.h3`
  color: var(--text-primary);
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: color 0.3s ease;
`;

const SettingItem = styled.div`
  margin-bottom: 12px;
  font-size: 0.875rem;
`;

const SettingLabel = styled.span`
  color: var(--text-secondary);
  font-weight: 500;
  transition: color 0.3s ease;
`;

const SettingValue = styled.span`
  color: var(--text-primary);
  font-weight: 600;
  font-family: 'Monaco', 'Menlo', monospace;
  background: var(--bg-tertiary);
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
  transition: all 0.3s ease;
`;

const StatusBadge = styled.span<{ status: boolean }>`
  background: ${props => props.status ? '#22c55e' : '#ef4444'};
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
`;

interface StatisticsPanelProps {
  wallets: Wallet[];
  config: Config | null;
  isConfigured: boolean;
}

const StatisticsPanel: React.FC<StatisticsPanelProps> = ({ 
  wallets, 
  config, 
  isConfigured 
}) => {
  const totalWallets = wallets.length;
  const activeBuyers = wallets.filter(w => 
    w.strategyStatus === 'running' && 
    w.strategyId && 
    w.strategyAction === 'buy'
  ).length;
  const activeSellers = wallets.filter(w => 
    w.strategyStatus === 'running' && 
    w.strategyId &&
    w.strategyAction === 'sell'
  ).length;
  return (
    <>
      <StatsContainer>
        <StatCard>
          <StatValue>
            <StatIcon>🔴</StatIcon>
            {totalWallets}
          </StatValue>
          <StatLabel>Total Wallets</StatLabel>
        </StatCard>
{/* 
        <StatCard>
          <StatValue>
            <StatIcon>💎</StatIcon>
            {totalETH.toFixed(3)}
          </StatValue>
          <StatLabel>Total ETH</StatLabel>
        </StatCard> */}

        <StatCard>
          <StatValue>
            <StatIcon>🚀</StatIcon>
            {activeBuyers}
          </StatValue>
          <StatLabel>Active Buyers</StatLabel>
        </StatCard>

        <StatCard>
          <StatValue>
            <StatIcon>📈</StatIcon>
            {activeSellers}
          </StatValue>
          <StatLabel>Active Sellers</StatLabel>
        </StatCard>

        <StatCard>
          <StatValue>
            <StatusBadge status={isConfigured}>
              {isConfigured ? 'ON' : 'OFF'}
            </StatusBadge>
          </StatValue>
          <StatLabel>API Status</StatLabel>
        </StatCard>

        {/* <StatCard>
          <StatValue>
            <StatIcon>🔍</StatIcon>
            Debug
          </StatValue>
          <StatLabel>
            API: {isConfigured ? 'ON' : 'OFF'} | NOT SET | Wallets: {totalWallets}
          </StatLabel>
        </StatCard> */}
      </StatsContainer>

      {isConfigured && config && (
        <SettingsContainer>
          <SettingsTitle>
            ⚙️ Current Settings
          </SettingsTitle>
          
          <SettingItem>
            <SettingLabel>RPC:</SettingLabel>
            <SettingValue>{config.rpcUrl || 'Not set'}</SettingValue>
          </SettingItem>
          
          <SettingItem>
            <SettingLabel>Target Token:</SettingLabel>
            <SettingValue>{config.tokenAddress || 'Not set'}</SettingValue>
          </SettingItem>
          
          <SettingItem>
            <SettingLabel>Quote Token:</SettingLabel>
            <SettingValue>{config.ethAddress || '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE'}</SettingValue>
          </SettingItem>
        </SettingsContainer>
      )}
    </>
  );
};

export default StatisticsPanel;
